// extracted by mini-css-extract-plugin
export default {"form":"Layouts_form__-SKBs","btnContainer":"Layouts_btnContainer__ZD1Nh","btn":"Layouts_btn__Y4Dhd"};